import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
import tokenHeader from '../token-header';
// const API_URL = 'https://localhost:9090 /api/all/ ';

 
const getSalesOrder = 'sales-order';
const getStatusPayment = 'finance/check-transaksi';
const postSalesOrderUrl = 'sales-order';
const putSalesOrder = 'sales-order/';
const deleteSalesOrder = 'sales-order/';

class SalesOrderService {
    getSalesOrder(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getSalesOrder+ '?pageNo='+currentPage+'&pageSize='+pageSize+'&filter='+filter,
            {
                headers: authHeader()
            });
    }

    checkStatus(idPayment) {
        return axios.get(
            API_URL + getStatusPayment+'?transactionId=' + idPayment,
            {
                headers: authHeader()
            });
    }

    postSalesOrder(formData) {        
        return axios
        .post(
            API_URL + postSalesOrderUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putSalesOrder(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putSalesOrder + formData.idSalesOrder, formData,
            { headers: authHeader() }
        );
    }

    deleteSalesOrder(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteSalesOrder + formData.idSalesOrder,
                { headers: authHeader() }
            );
    }

}

export default new SalesOrderService();